<template>
    <b-card no-body >
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-companies variant="info">
                <b-icon icon="search" aria-hidden="true"></b-icon>
                Filtro de busqueda
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-companies">
            <b-card-body>
                <b-card-text>
                    <b-row>        
                        <b-col cols="12" md="4">
                            <label for="companyName">Nombre Empresa</label>
                            <b-form-input id="companyName" v-model="filter.companyName" @keydown.enter.prevent="$emit('get-companies')" placeholder="Nombre Empresa"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <label for="companyNit">Nit Empresa</label>
                            <b-form-input id="companyNit" v-model="filter.companyNit" @keydown.enter.prevent="$emit('get-companies')" placeholder="Nit Empresa"></b-form-input>
                        </b-col>
                        
                        <b-col cols="12" md="12" class="pt-2">
                            <div >
                                <b-button variant="info" @click.prevent="$emit('get-companies')" >
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                    Buscar
                                </b-button>
                                <b-button variant="warning" @click.prevent="$emit('clear-filter-form')" class="mx-1 text-white">
                                    <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                    Limpiar
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card-body>
        </b-collapse>
    </b-card>
    
</template>

<script>
export default {
    name: "FilterForm",
    props: {
        filter: {
            type: Object
        }
    }
};

</script>